import PaginatedTable from '../../components/ui/PaginatedTable';
import { useState, useEffect } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function VendorPurchaseOrders() {
  const [selectedPO, setSelectedPO] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const [vendorPOs, setVendorPOs] = useState([]);
  const [vendor, setVendor] = useState(null);
  const [quotationPrices, setQuotationPrices] = useState({});
  const [deliveryDays, setDeliveryDays] = useState("");

  useEffect(() => {
    fetch("/api/vendor/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setVendor(data.vendor);
          console.log(data.vendor);
        }
      });

    fetch("/api/vendor/purchase-orders", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setVendorPOs(data.data || []);
        }
      });
  }, []);

  const myOrders = vendorPOs;

  const filteredOrders = showAll
    ? myOrders
    : myOrders.filter((po) => po.status !== "Approved");

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-serif">My Purchase Orders</h1>
            <p className="text-sm text-gray-400">
              Orders assigned to {vendor?.name || "..."}
            </p>
          </div>

          <button
            onClick={() => setShowAll(!showAll)}
            className={`px-6 py-2 rounded-xl border text-sm transition
      ${
        showAll
          ? "bg-amber-400 text-black border-amber-400"
          : "border-white/20 hover:bg-white/5"
      }`}
          >
            {showAll ? "Show Pending Only" : "Show All POs"}
          </button>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {filteredOrders.map((po) => (
            <div
              key={po.id}
              className="rounded-2xl bg-white/5 border border-white/10 p-6 hover:border-amber-400/40 transition cursor-pointer"
              onClick={async () => {
                const res = await fetch(
                  `/api/purchase-orders/${po.id}`,
                  {
                    credentials: "include",
                  },
                );

                const data = await res.json();

                if (data.status === "success") {
                  setSelectedPO(data.data);

                  // 🔥 FETCH EXISTING QUOTATION
                  const qRes = await fetch(
                    `/api/vendor/quotation/${po.id}`,
                    {
                      credentials: "include",
                    },
                  );

                  const qData = await qRes.json();

                  if (qData.data) {
                    // 🔥 CONVERT ARRAY → OBJECT
                    const priceMap = {};

                    qData.data.items.forEach((item) => {
                      priceMap[item.name] = item.price;
                    });

                    setQuotationPrices(priceMap);
                    setDeliveryDays(qData.data.delivery_days);
                  } else {
                    setQuotationPrices({});
                    setDeliveryDays("");
                  }
                }
              }}
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-medium text-lg">{po.po_number}</p>
                  <p className="text-xs text-gray-400">
                    Delivery to: {po.location || "—"}
                  </p>
                </div>

                <StatusBadge
                  status={po.status}
                  expected={po.delivery_date}
                  delivered={po.deliveredDate}
                />
              </div>

              <div className="mt-4 text-sm text-gray-300">
                <p>Expected Delivery: {po.delivery_date || "—"}</p>
                <p>Priority: {po.priority || "Normal"}</p>
              </div>
            </div>
          ))}
        </div>

        {myOrders.length === 0 && (
          <div className="text-center text-gray-400 py-20">
            No purchase orders assigned yet
          </div>
        )}
      </div>

      {selectedPO && (
        <Modal onClose={() => setSelectedPO(null)}>
          <div className="space-y-8">
            {/* Header */}
            <div className="border-b border-white/10 pb-5">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-serif">
                    {selectedPO.po_number}
                  </h2>

                  <p className="text-sm text-gray-400 mt-1">Purchase Order</p>
                </div>

                <span
                  className={`px-4 py-1 rounded-full text-sm
            ${
              selectedPO.status === "Approved"
                ? "bg-emerald-500/20 text-emerald-400"
                : "bg-amber-500/20 text-amber-400"
            }`}
                >
                  {selectedPO.status}
                </span>
              </div>
            </div>

            {/* Basic Details */}
            <div className="grid md:grid-cols-2 gap-6">
              <div className="rounded-xl bg-white/5 p-4 border border-white/10">
                <p className="text-xs uppercase text-gray-500">
                  Delivery Location
                </p>

                <p className="mt-2 text-lg">{selectedPO.location}</p>
              </div>

              <div className="rounded-xl bg-white/5 p-4 border border-white/10">
                <p className="text-xs uppercase text-gray-500">
                  Expected Delivery
                </p>

                <p className="mt-2 text-lg">{selectedPO.delivery_date}</p>
              </div>
            </div>

            {/* Items */}
            <div>
              <h3 className="font-semibold mb-4">Requested Items</h3>

              <div className="overflow-x-auto">
                <PaginatedTable className="w-full text-sm">
                  <thead className="bg-white/5">
                    <tr>
                      <th className="text-left p-3">Item</th>

                      <th className="text-center">Qty</th>

                      <th className="text-center">Unit</th>

                      <th className="text-center">Quality</th>

                      <th className="text-center">Packaging</th>

                      <th className="text-center">Brand</th>

                      <th className="text-right">Your Price</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedPO.items.map((item, index) => (
                      <tr key={index} className="border-t border-white/10">
                        <td className="p-3 font-medium">{item.name}</td>

                        <td className="text-center">{item.qty}</td>

                        <td className="text-center">{item.unit}</td>

                        <td className="text-center">{item.quality || "-"}</td>

                        <td className="text-center">{item.packaging || "-"}</td>

                        <td className="text-center">{item.brand || "-"}</td>

                        <td className="text-right">
                          <input
                            type="number"
                            value={quotationPrices[item.name] || ""}
                            placeholder="₹"
                            className="w-28 rounded-lg bg-black/40 border border-white/10 px-3 py-2 text-right"
                            onChange={(e) =>
                              setQuotationPrices({
                                ...quotationPrices,
                                [item.name]: Number(e.target.value),
                              })
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </PaginatedTable>
              </div>
            </div>

            {/* Delivery Time */}

            <div className="rounded-xl bg-white/5 border border-white/10 p-5">
              <h3 className="font-semibold mb-3">Delivery Commitment</h3>

              <div className="flex items-center gap-4">
                <input
                  type="number"
                  className="w-32 rounded-lg bg-black/40 border border-white/10 px-3 py-2"
                  value={deliveryDays}
                  onChange={(e) => setDeliveryDays(e.target.value)}
                />

                <span className="text-gray-400">Days</span>
              </div>
            </div>

            {/* Notes */}

            {selectedPO.notes && (
              <div className="rounded-xl bg-white/5 border border-white/10 p-5">
                <h3 className="font-semibold mb-3">Purchase Notes</h3>

                <p className="text-gray-300 whitespace-pre-wrap">
                  {selectedPO.notes}
                </p>
              </div>
            )}

            {/* Terms */}

            {selectedPO.terms && (
              <div className="rounded-xl bg-white/5 border border-white/10 p-5">
                <h3 className="font-semibold mb-3">Terms & Conditions</h3>

                <div className="text-gray-300 whitespace-pre-wrap leading-7">
                  {selectedPO.terms}
                </div>
              </div>
            )}

            {/* Footer */}

            <div className="flex justify-end gap-4 pt-4 border-t border-white/10">
              <button
                onClick={() => setSelectedPO(null)}
                className="px-6 py-2 rounded-lg border border-white/10"
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  const payload = {
                    po_id: selectedPO.id,
                    vendor_id: vendor.id,
                    delivery_days: Number(deliveryDays),

                    items: selectedPO.items.map((i) => ({
                      name: i.name,
                      qty: i.qty,
                      price: quotationPrices[i.name] || 0,
                    })),
                  };

                  const res = await fetch(
                    "/api/vendor/submit-quotation",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      credentials: "include",
                      body: JSON.stringify(payload),
                    },
                  );

                  const data = await res.json();

                  if (data.status === "success") {
                    alert("Quotation submitted successfully.");
                    setSelectedPO(null);
                  } else {
                    alert(data.message);
                  }
                }}
                className="px-8 py-2 rounded-lg bg-amber-400 text-black font-semibold"
              >
                {Object.keys(quotationPrices).length
                  ? "Update Quotation"
                  : "Submit Quotation"}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </DashboardLayout>
  );
}

// ✅ UNCHANGED
function StatusBadge({ status, expected, delivered }) {
  if (status === "Approved") {
    return (
      <span className="px-3 py-1 rounded-full text-xs bg-emerald-500/20 text-emerald-400">
        Approved
      </span>
    );
  }

  const late = delivered && delivered > expected;

  return (
    <span
      className={`px-3 py-1 rounded-full text-xs ${
        late ? "bg-red-500/20 text-red-400" : "bg-amber-400/20 text-amber-400"
      }`}
    >
      {late ? "Late" : "Pending"}
    </span>
  );
}

function InfoCard({ title, value }) {
  return (
    <div className="rounded-xl bg-black/30 border border-white/10 p-4">
      <p className="text-xs uppercase tracking-wider text-gray-400">{title}</p>

      <p className="mt-2 text-base font-medium">{value}</p>
    </div>
  );
}

// ✅ UNCHANGED
function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex min-h-screen items-center justify-center">
      <div className="w-full max-w-3xl rounded-2xl bg-[#0b0b0f] border border-white/10 p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}
